import { useEffect, useState } from 'react'

/*
 * QR-codes. KaartQr: de eigen kaart, om op de telefoon te laten zien in plaats
 * van de plastic kaart. Inhoud: de link met ?code=..., die de tablet net zo
 * leest als de kaart zelf, en die op een andere telefoon het saldo opent.
 * Het pakket wordt pas geladen als iemand de code opent.
 */

/** Een QR-code op een wit vlak, voor elke inhoud (link of tekst). */
export function QrVlak({ inhoud, label }: { inhoud: string; label?: string }) {
  const [pad, zetPad] = useState<{ d: string; n: number } | null>(null)
  useEffect(() => {
    let weg = false
    import('qrcode-generator').then(({ default: qrcode }) => {
      const qr = qrcode(0, 'M')
      qr.addData(inhoud)
      qr.make()
      const n = qr.getModuleCount()
      let d = ''
      for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c + 4},${r + 4}h1v1h-1z`
      if (!weg) zetPad({ d, n: n + 8 })
    }).catch(() => { /* zonder QR blijft de tekst ernaast leesbaar */ })
    return () => { weg = true }
  }, [inhoud])
  return (
    <div className="kaart-qr-vlak">
      {pad
        ? <svg viewBox={`0 0 ${pad.n} ${pad.n}`} shapeRendering="crispEdges" role="img" aria-label={label ?? 'QR-code'}>
            <rect width={pad.n} height={pad.n} fill="#fff" /><path d={pad.d} fill="#000" />
          </svg>
        : <div className="kaart-qr-laden" />}
    </div>
  )
}

export function KaartQr({ code }: { code: string }) {
  return (
    <div className="kaart-qr">
      <QrVlak inhoud={`${location.origin}/?code=${encodeURIComponent(code)}`} label={`QR-code van kaart ${code}`} />
      <b className="code-pil kaart-qr-code">{code}</b>
      <p className="stil klein">Houd je telefoon voor de camera van de tablet bij de kassa. Lukt het niet? Zet je scherm wat feller.</p>
    </div>
  )
}
